import { useState, useEffect, useRef } from "react";
import SocialGlassPills from "../components/SocialGlassPills";
import SummaryModule from "../components/breakdown/modules/SummaryModule";
import ClusterData from "../components/breakdown/ClusterData";
import { motion, AnimatePresence } from "framer-motion";
import PatternAndCluster from "../components/breakdown/modules/PatternAndCluster";
import KeySubtopicModule from "../components/breakdown/modules/KeySubtopicModule";
import axios from "axios";
import VibeGridModule from "../components/breakdown/modules/VibeGridModule";
import MediaComponent from "../MediaComponent";
import SocialGlassSpotlight from "../components/breakdown/modules/SocialGlassSpotlight";
import { decryptfromHEX } from "../../routes/encodedecode";
//Implement our own stack grid since it's causing UI issues

import WaterfallGrid from "../../SocialGlass/components/breakdown/WaterfallGrid";
import PostBaseTemplate from "../../components/socialglass/PostBaseTemplate";

function SocialGlassBreakdown() {
  const [choosenPill, setChoosenPill] = useState("");
  const [sampleData, setSampleData] = useState([]);
  const [categoryToData, setCategoryToData] = useState({});
  const [currentJsonData, setCurrentJsonData] = useState({});
  const [clusterData, setClusterData] = useState({});
  const [idToData, setIdToData] = useState({});
  const [vibeGridPostIds, setvibeGridPostIds] = useState([]);
  const [vibeGridName, setVibeGridName] = useState("");

  const videoRefs = useRef({});

  const fetchVibeGridData = async (postIds) => {
    try {
      const queryString = postIds
        .filter((postId) => postId !== "")
        .map((post) => `postIDs=${post}`)
        .join("&");

      const videoResponse = await axios.get(
        `https://genz-staging.feeltiptop.com/api/social_glass/getPostsDataArr?${queryString}`,
      );

      const responseData = videoResponse.data;

      if (Array.isArray(responseData?.data)) {
        const videoData = responseData.data.reduce((acc, item) => {
          acc[item.post_id] = item;
          return acc;
        }, {});
        setIdToData(videoData);
      } else {
        console.error("Invalid video data format:", responseData);
        setIdToData({});
      }
    } catch (error) {
      console.error("Error fetching VibeGrid data:", error);
      setIdToData({});
    }
  };

  useEffect(() => {
    const fetchBreakdownData = async () => {
      const queryParams = new URLSearchParams(window.location.search);
      const encrypted = queryParams.get("p");
      let orgID = "";

      if (encrypted) {
        try {
          const decrypted = decryptfromHEX(encrypted);
          const parsed = JSON.parse(decrypted);
          orgID = parsed.orgID;
        } catch (err) {
          console.error("Failed to decrypt orgID from URL:", err);
        }
      }

      try {
        const response = await axios.get(
          "https://genz-staging.feeltiptop.com/api/user/get_report",
          {
            params: {
              p: orgID,
              section: "Breakdown",
            },
          },
        );

        const breakdownData = response.data;
        const categories = breakdownData?.CategoriesList;
        const vibePostIds = [];

        if (Array.isArray(categories)) {
          let initialPillSet = false;

          const tempSampleData = [];
          const tempCategoryMap = {};

          categories.forEach((category) => {
            console.log("category being seen: ", category?.VibeGridMetaData);

            //We don't need this, we can move to using the dictionary of data
            // if (
            //   category?.VibeGridMetaData?.VibeGridPostIds &&
            //   category?.VibeGridMetaData?.VibeGridPostIds.length > 0
            // ) {
            //   console.log("true here");
            //   setVibeGridName(category?.VibeGridMetaData?.VibeGridTitle);
            //   for (
            //     let i = 0;
            //     i < category?.VibeGridMetaData?.VibeGridPostIds.length;
            //     i++
            //   ) {
            //     vibePostIds.push(category.VibeGridMetaData.VibeGridPostIds[i]);
            //   }
            // }
            if (!initialPillSet) {
              setChoosenPill(category.categoryName);
              initialPillSet = true;
            }
            tempSampleData.push(category.categoryName);
            tempCategoryMap[category.categoryName] = category;
          });

          //Set up the data with these respetive data
          setSampleData(tempSampleData); //
          setCategoryToData(tempCategoryMap); //Gets the data for that category
        }

        // const postIds = breakdownData?.CategoriesList?.VibeGridPostIds;

        //No longer needed, we can just get the data from the dictionary
        if (Array.isArray(vibePostIds)) {
          await fetchVibeGridData(vibePostIds);
        }
      } catch (err) {
        setSampleData([]);
        setCategoryToData({});
      }
    };

    const breakpointColumnsObj = {
      default: 4,
      1100: 3,
      700: 2,
      500: 1,
    };

    const fetchVibeGridData = async (postIds) => {
      try {
        const queryString = postIds
          .filter((postId) => postId !== "")
          .map((post) => `postIDs=${post}`)
          .join("&");

        const videoResponse = await axios.get(
          `https://genz-staging.feeltiptop.com/api/social_glass/getPostsDataArr?${queryString}`,
        );

        const responseData = videoResponse.data;

        if (Array.isArray(responseData?.data)) {
          const videoData = responseData.data.reduce((acc, item) => {
            acc[item.post_id] = item;
            return acc;
          }, {});
          setIdToData(videoData);
        } else {
          console.error("Invalid video data format:", responseData);
          setIdToData({});
        }
      } catch (error) {
        console.error("Error fetching VibeGrid data:", error);
        setIdToData({});
      }
    };

    fetchBreakdownData();
  }, []);

  useEffect(() => {
    console.log(
      "current json data we're looking at: ",
      categoryToData[choosenPill],
    );

    if (categoryToData[choosenPill] !== undefined) {
      const data = categoryToData[choosenPill];
      setCurrentJsonData(categoryToData[choosenPill]);
      setClusterData(categoryToData[choosenPill].InsightCluster);

      fetchVibeGridData(data.VibeGridMetaData?.VibeGridPostIds);
      if (data.VibeGridMetaData?.VibeGridTitle) {
        setVibeGridName(data.VibeGridMetaData?.VibeGridTitle);
      }
    }
  }, [choosenPill, categoryToData]);

  return (
    <AnimatePresence>
      <motion.div
        key="breakdown"
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: -50 }}
        transition={{ duration: 0.4 }}
        style={{ fontFamily: "Acumin Variable Concept, sans-serif" }}
        className="h-full w-full space-y-20 px-6"
      >
        <div className="flex h-auto w-full flex-wrap items-start justify-start">
          {sampleData.map((title) => (
            <SocialGlassPills
              key={title}
              title={title}
              choosenPill={choosenPill}
              setChoosenPill={setChoosenPill}
            />
          ))}
        </div>

        {choosenPill && (
          <AnimatePresence mode="wait">
            <motion.div
              key={choosenPill}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -20 }}
              transition={{ duration: 0.3 }}
              className="h-auto w-full space-y-20 pb-4"
            >
              {/* Insight Cluster data */}

              {/* Spotlight Section */}

              <section id="overview-summary" className="flex flex-col">
                <div className="flex space-x-4">
                  <h1 className="text-2xl font-bold">{choosenPill}</h1>
                  <p className="text-xl font-extralight">
                    {currentJsonData?.numberOfPosts} submitted posts
                  </p>
                </div>
                <p className="text-start font-bold italic">
                  This Cycles Movement
                </p>

                {currentJsonData && (
                  <div className="flex flex-col space-y-8">
                    {/* Key shifts */}
                    {currentJsonData.keyShifts &&
                      currentJsonData.keyShifts.length > 0 && (
                        <SummaryModule
                          title={"Key Shifts"}
                          content={currentJsonData.keyShifts}
                        />
                      )}

                    {/* Overall insights */}
                    {currentJsonData.overallInsights &&
                      currentJsonData.overallInsights.length > 0 && (
                        <SummaryModule
                          title={"Topics Insight Summary"}
                          content={currentJsonData.overallInsights}
                        />
                      )}
                  </div>
                )}
              </section>

              <section
                id="cluster-patterns-subtopics"
                className="grid grid-cols-2"
              >
                {currentJsonData && currentJsonData.KeyPatternsAndClusters && (
                  <PatternAndCluster
                    KeyPatternsAndClusters={
                      currentJsonData.KeyPatternsAndClusters
                    }
                    // col={true}
                    // colSpan={2}
                  />
                )}

                {currentJsonData &&
                  currentJsonData.KeySubtopicsThroughout &&
                  currentJsonData.KeySubtopicsThroughout.length > 0 && (
                    <KeySubtopicModule
                      KeySubtopicsThroughout={
                        currentJsonData.KeySubtopicsThroughout
                      }
                    />
                  )}
              </section>

              <section id="cluster-data" className="space-y-8">
                {currentJsonData &&
                  clusterData.length > 0 &&
                  clusterData.map((cluster, idx) =>
                    cluster.spotlight === false ? (
                      <ClusterData
                        key={`cluster-${idx}`}
                        clusterName={cluster?.clusterName}
                        clusterData={cluster}
                      />
                    ) : (
                      <SocialGlassSpotlight
                        key={`spotlight-${idx}`}
                        spotlightData={cluster}
                      />
                    ),
                  )}
              </section>
            </motion.div>
          </AnimatePresence>
        )}

        {/* switch this to the one inside each cluster data later:  */}

        {/* {currentJsonData?.spotlight && <SocialGlassSpotlight />} */}
        {currentJsonData?.VibeGridMetaData?.VibeGridPostIds &&
          currentJsonData?.VibeGridMetaData?.VibeGridPostIds.length > 0 && (
            <div className="h-[800px] w-auto max-w-[700px] overflow-hidden shadow-socialglass">
              <VibeGridModule
                postCount={
                  currentJsonData?.VibeGridMetaData?.VibeGridPostIds.length
                }
                vibeGridTitle={vibeGridName}
              >
                <div className="h-full overflow-y-auto">
                  <WaterfallGrid columns={4}>
                    {currentJsonData?.VibeGridMetaData?.VibeGridPostIds.map(
                      (postId, idx) => (
                        <div
                          key={postId}
                          className={`mb-0 h-full w-full rounded-md pb-0`}
                        >
                          <PostBaseTemplate
                            platform={idToData[postId]?.platform?.toLowerCase()}
                            url={idToData[postId]?.url}
                            width="150px"
                            showPlatformName={false}
                          >
                            <MediaComponent
                              postId={postId}
                              username=""
                              index={idx}
                              idToData={idToData}
                              videoRefs={videoRefs}
                              handleManualMute={() => {}}
                              handleManualUnmute={() => {}}
                              muted={true}
                              caption=""
                              showIcon={true}
                              rounded={false}
                            />
                          </PostBaseTemplate>
                        </div>
                      ),
                    )}
                  </WaterfallGrid>
                </div>
              </VibeGridModule>
            </div>
          )}
      </motion.div>
    </AnimatePresence>
  );
}

export default SocialGlassBreakdown;
